const marginTopAllComponent = () =>{
    return "120px";
}

export default marginTopAllComponent;